export default {
  init() {

    /*if ($.browser.msie) {
      $('img').bicubicImgInterpolation({
        crossOrigin: 'anonymous', //otherwise browser security error is triggered
      });
    }*/

    $('.blr-newsticker-wrapper').each(function () {
      var parent = $(this);
      setTimeout(function () {
        var current = parent.find('.blr-newsticker .item_1');
        console.log(current.length);
        if (current.length) {
          scrollToNext(parent, current);
        }
      }, 10000);
    });

    $('.blr-team-slider').slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
    });


  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};

function scrollToNext(parent, current) {
  var next = current.next();
  if (!next) {
    next = parent.find('.blr-newsticker .item_1');
  }
  if (next) {
    parent.find('.blr-newsticker').animate({
      scrollTop: parent.find('.blr-newsticker').scrollTop() + next.position().top,
    }, 500, 'swing');

    setTimeout(function () {
      scrollToNext(parent, next);
    }, 10000);
  }
}



// WEBPACK FOOTER //
// ./scripts/routes/common.js